import React from 'react'
import cx from 'classnames'

import SimpleSelect from 'components/_new/forms/SimpleSelect/SimpleSelect'

import s from './SkinTypeSelect.scss'
import messages from './messages'


const options = [
  'Normal',
  'Dry',
  'Oily',
  'Combination',
  'Sensitive',
]
  .map((value) => ({ title: value, value }))

const SkinTypeSelect = ({ className, field }) => (
  <SimpleSelect
    className={cx(className, s.skinTypeSelect)}
    field={field}
    options={options}
    placeholder={messages.placeholder}
  />
)


export default SkinTypeSelect
